import React from "react";

export const Envelope = ({
  width = "33",
  height = "32",
  color = "#202020",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.752 6H4.75195C4.48674 6 4.23238 6.10536 4.04485 6.29289C3.85731 6.48043 3.75195 6.73478 3.75195 7V24C3.75195 24.5304 3.96267 25.0391 4.33774 25.4142C4.71281 25.7893 5.22152 26 5.75195 26H27.752C28.2824 26 28.7911 25.7893 29.1662 25.4142C29.5412 25.0391 29.752 24.5304 29.752 24V7C29.752 6.73478 29.6466 6.48043 29.4591 6.29289C29.2715 6.10536 29.0172 6 28.752 6ZM16.752 16.6437L7.3232 8H26.1807L16.752 16.6437ZM13.0907 16L5.75195 22.7262V9.27375L13.0907 16ZM14.5707 17.3563L16.0707 18.7375C16.2552 18.9069 16.4965 19.0008 16.747 19.0008C16.9974 19.0008 17.2387 18.9069 17.4232 18.7375L18.9232 17.3563L26.1732 24H7.3232L14.5707 17.3563ZM20.4132 16L27.752 9.2725V22.7275L20.4132 16Z"
        fill={color}
      />
    </svg>
  );
};
